// extracted by mini-css-extract-plugin
module.exports = {"restaurants-menus-icons-label":"_2snys","restaurantsMenusIconsLabel":"_2snys"};